<template>
    <div class="register-card-wrapper">
        <img height="50px" width="120px" src="https://res.cloudinary.com/campusedu/image/upload/v1605047001/campus-logos/CampusLogo.3-1_i6oeos.png" />
        <h1 class="my-2 text-center">
            Register for
            <span class="text-decoration-underline">{{
                selectedClass.className
            }}</span
            ><br />
            <span class="text-uppercase text-decoration-underline">{{
                selectedClass.class
            }}</span>
            at
            <span class="text-decoration-underline">{{
                selectedClass.friendly
            }}</span
            >!
        </h1>
        <v-card class="mx-auto" width="500px">
            <v-form v-model="isValid" ref="registerForm">
                <v-card-text>
                    <v-text-field
                        label="Full Name"
                        prepend-icon="mdi-account"
                        v-model="fullName"
                        required
                    />

                    <v-text-field
                        label="School Email Address"
                        prepend-icon="mdi-email"
                        v-model="email"
                        :rules="[v => !!v || 'Email is required']"
                        required
                    />

                    <v-menu
                        ref="birthDateMenu"
                        v-model="birthDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="birthDate"
                                label="Birth Date"
                                prepend-icon="mdi-calendar"
                                :rules="[v => !!v || 'Birth date is required']"
                                required
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            ref="birthDatePicker"
                            v-model="birthDate"
                            :max="new Date().toISOString().substr(0, 10)"
                            @change="birthDateSave"
                        ></v-date-picker>
                    </v-menu>

                    <v-autocomplete
                        v-model="homeInstitution"
                        :items="retrievedSchools"
                        item-text="friendly"
                        item-value="name"
                        label="Search for Your Home Institution"
                        :hint="
                            `Current Student at ${this.homeInstitution.friendly}`
                        "
                        required
                        :rules="[v => !!v || 'Home institution is required']"
                        return-object
                        single-line
                    ></v-autocomplete>

                    <v-autocomplete
                        v-model="term"
                        :items="retrievedTerms"
                        item-value="name"
                        label="Select a Term"
                        :hint="`Which term are you registering for?`"
                        required
                        :rules="[v => !!v || 'Term is required']"
                        return-object
                        single-line
                    >
                        <template slot="selection" slot-scope="data">
                            {{ data.item.name }} - Starts
                            {{ data.item.startDate | formatPrettyDate }} : Ends
                            {{ data.item.endDate | formatPrettyDate }}
                        </template>
                        <template slot="item" slot-scope="data">
                            {{ data.item.name }} - Starts
                            {{ data.item.startDate | formatPrettyDate }} : Ends
                            {{ data.item.endDate | formatPrettyDate }}
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-card-text>
                    <v-btn
                        block
                        color="primary"
                        elevation="2"
                        @click="register"
                        :disabled="!isValid"
                        >Register Now</v-btn
                    >
                </v-card-text>
            </v-form>
        </v-card>
        <v-row justify="center">
            <v-dialog
                v-model="registerModalToggle"
                v-if="registerModalToggle"
                persistent
                max-width="500"
            >
                <v-card>
                    <v-card-title
                        block
                        class="headline text-center"
                        :color="modalInfo.color"
                    >
                        <v-icon> {{ modalInfo.icon }} </v-icon>
                        {{ modalInfo.title }}
                    </v-card-title>
                    <v-card-text v-html="modalInfo.message"></v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            block
                            :color="modalInfo.color"
                            elevation="2"
                            @click="hideRegisterModal()"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<style lang="scss">
.register-card-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
}
</style>

<script>
import axios from "axios";
import moment from "moment";

export default {
    name: "RegisterCard",
    components: {},
    data() {
        return {
            API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
            baseUrl: url => `${this.API_BASE_URL}/${url}`,
            registerModalToggle: false,
            modalInfo: {
                color: "primary",
                icon: "mdi-help-circle-outline",
                title: "Unknown",
                message: "???"
            },
            isValid: false,
            retrievedSchools: null,
            retrievedCourses: null,
            retrievedTerms: null,
            registerResponse: null,
            fullName: null,
            email: null,
            homeInstitution: { friendly: "" },
            birthDate: null,
            birthDateMenu: false,
            selectedClass: {
                class: "",
                className: "",
                school: "",
                friendly: ""
            }
        };
    },
    mounted() {
        this.getData();
    },
    watch: {
        birthDateMenu(val) {
            val &&
                setTimeout(
                    () => (this.$refs.birthDatePicker.activePicker = "YEAR")
                );
        }
    },
    filters: {
        formatPrettyDate: function(value) {
            if (value) {
                return moment(String(value)).format("MMM D YYYY");
            }
        }
    },
    methods: {
        birthDateSave(date) {
            this.$refs.birthDateMenu.save(date);
        },
        showRegisterModal(color, icon, title, message) {
            this.registerModalToggle = true;
            this.modalInfo.color = color;
            this.modalInfo.icon = icon;
            this.modalInfo.title = title;
            this.modalInfo.message = message;
        },
        hideRegisterModal() {
            this.registerModalToggle = false;
        },
        register() {
            const registerUrl = this.baseUrl("api/createRegistration");
            let registeringData = {
                birthDate: this.birthDate,
                courseCode: this.selectedClass.class,
                email: this.email,
                fullName: this.fullName,
                homeInstitution: this.homeInstitution.name,
                offeringInstitution: this.selectedClass.school,
                termCode: this.term.code
            };
            axios
                .post(registerUrl, registeringData)
                .then(response => (this.registerResponse = response.data))
                .then(() => {
                    if (this.registerResponse.httpCode == "500") {
                        this.showRegisterModal(
                            "error",
                            "mdi-alert-circle-outline",
                            "Already Registered!",
                            `We already have a registration submitted for the following:<br /><br />
                            <span class="font-weight-bold">Registeration Email: </span>${this.email}<br />
                            <span class="font-weight-bold">Class: </span>${this.selectedClass.class} at <span class="text-capitalize">${this.selectedClass.friendly}</span><br />
                            <span class="font-weight-bold">Term: </span>${this.term.name}<br /><br />
                            <span class="font-weight-black text-center">Please check your email for a Registration Confirmation email.</span>`
                        );
                    } else if (this.registerResponse.status == 500) {
                        this.showRegisterModal(
                            "error",
                            "mid-alert-circle-outline",
                            this.registerResponse.message,
                            this.registerResponse.detail
                        );
                    } else if (this.registerResponse.httpCode == "200") {
                        this.showRegisterModal(
                            "success",
                            "mdi-check-circle-outline",
                            "Registration Complete!",
                            `You're all set! Below is your confirmation id. You will also receive an email shortly with the full confirmation information. Please save this information for future reference.<br /><br />
                            <span class="font-weight-bold">Name: </span>${this.fullName}<br />
                            <span class="font-weight-bold">Registeration Email: </span>${this.email}<br />
                            <span class="font-weight-bold">Class: </span>${this.selectedClass.class} at <span class="text-capitalize">${this.selectedClass.friendly}</span><br />
                            <span class="font-weight-bold">Term: </span>${this.term.name}<br />
                            <span class="font-weight-bold">Confirmation ID: </span>${this.registerResponse.guid}<br /><br />
                            <span class="font-weight-black text-center">You may now close this Class Registration Page</span>`
                        );
                    } else {
                        console.log(JSON.stringify(this.registerResponse));
                        this.showRegisterModal();
                    }
                })
                .catch(error => {
                    if (
                        error.response.data.detail ==
                        "Invalid or Missing Course"
                    ) {
                        this.showRegisterModal(
                            "error",
                            "mid-alert-circle-outline",
                            "Invalid Course Number",
                            `The course you are looking for isn't valid or is no longer available. Please return to <a href="https://www.campusedu.com/courses">Campus Courses</a>, search for the course and click "Register".`
                        );
                    } else {
                        this.showRegisterModal(
                            "error",
                            "mid-alert-circle-outline",
                            "System Error",
                            `Server Response: ${error.response.data.message} - ${error.response.data.detail}`
                        );
                    }
                });
        },
        async getData() {
            const getInstUrl = this.baseUrl("api/institutions?size=10000&sort=friendly");
            const getCoursesUrl = this.baseUrl("api/courses?size=10000");
            const getTermsUrl = this.baseUrl("api/terms?size=10000&sort=startDate");

            await axios
                .get(getInstUrl)
                .then(response => (this.retrievedSchools = response.data));
            await axios
                .get(getTermsUrl)
                .then(response => (this.retrievedTerms = response.data));
            await axios
                .get(getCoursesUrl)
                .then(response => (this.retrievedCourses = response.data))
                .then(() => {
                    let course = this.retrievedCourses.find(
                        course =>
                            course.code.toLowerCase() ===
                            this.$route.query.class.toLowerCase()
                    );
                    if (typeof course == "undefined") {
                        this.showRegisterModal(
                            "error",
                            "mid-alert-circle-outline",
                            "Invalid Course Number",
                            `The course you are looking for isn't valid or is no longer available. Please return to <a href="https://www.campusedu.com/courses">Campus Courses</a>, search for the course and click "Register".`
                        );
                    } else {
                        let course = this.retrievedCourses.find(
                            course =>
                                course.code.toLowerCase() ===
                                this.$route.query.class.toLowerCase()
                        );
                        this.selectedClass.class = course.code;
                        this.selectedClass.className = course.name;
                        this.selectedClass.school = course.institution.name;
                        this.selectedClass.friendly = course.institution.friendly;
                    }
                });
        }
    }
};
</script>
